import CarDetailPanel from "../components/PageParts/Pages/Cars/CarDetailPanel";

export const routes = [
  { path: "/", component: null },
  { path: "/:id", component: CarDetailPanel },
  { path: "*", component: null }
];
